<script setup lang="ts">
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import {onBeforeMount} from "vue";
import PageTitle from "@/components/settings/PageTitle.vue";
import QuestionFieldsEditor from "@/components/questionFields/QuestionFieldsEditor.vue";
import Translator from "@/utils/common/Translator.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {useMessagesStore} from "@/stores/ToastDataStore.ts";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import QuestionField = namaTypes.QuestionField;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;

const {compactMode} = storeToRefs(useNamaFlagsStore());

let presenter: QuestionFieldsPresenter = new QuestionFieldsPresenter();
let questionFields: QuestionField[] = [];
let defaultValues: DTOFilledQuestionField[] = [
  {
    id: "userEmail",
    value: LoginUtils.loginInfo?.userInfo?.email,
    objValue: LoginUtils.loginInfo?.userInfo?.email
  }, {
    id: "mobile",
    value: LoginUtils.loginInfo?.userInfo?.settings?.mobile,
    objValue: LoginUtils.loginInfo?.userInfo?.settings?.mobile
  }
];

questionFields.push(NamaCommon.createQuestionField("userEmail", FieldType.Email));
questionFields.push(NamaCommon.createQuestionField("emailPassword", FieldType.Password));
questionFields.push(NamaCommon.createQuestionField("mobile", FieldType.PhoneNumber));

onBeforeMount(async () => {
  await presenter.edit(questionFields, defaultValues);
})

async function onSaveClick() {
  let changePasswordInfo: Record<string, any> = {
    userIdToChangePasswordFor: LoginUtils.currentUserId(),
    userEmail: presenter.fetchRecord().userEmail,
    emailPassword: presenter.fetchRecord().emailPassword,
    mobileNumber: presenter.fetchRecord().mobile,
    passwordMustBeChanged: false
  };
  let response = await NamaCommon.namaFetch(NamaURLS.Change_Password, {data: changePasswordInfo});
  if (response && response.result && response.result.succeded) {
    useMessagesStore().showSuccessMessage();
  }
}
</script>

<template>
  <div class="tw-mx-auto tw-w-full tw-max-w-6xl tw-space-y-6 tw-px-6">
    <section
      class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-namaBackground-deep-light tw-p-4
             dark:tw-border-gray-700 dark:tw-bg-namaBackground-deep-dark">
      <PageTitle title="editContactInfo" icon="nm-edit-text"/>
      <div class="tw-w-full tw-justify-items-center">
        <q-card-section
          class="tw-w-[70%] tw-shrink tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-h-fit tw-flex-nowrap tw-overflow-y-auto !tw-max-h-[90%]">
          <QuestionFieldsEditor :presenter="presenter" :singleColumnGroup="true" :doNotApplyThemeLayouts="true"/>
        </q-card-section>
        <q-card-section :dir="Translator.fetchDir()" class="tw-flex-none">
          <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-center ">
            <q-btn
              :label="Translator.translateId('save')"
              @click="onSaveClick()"
              :dense="compactMode"
              class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-base tw-font-normal tw-rounded-md tw-min-w-28 tw-max-w-fit"/>
          </div>
        </q-card-section>
      </div>
    </section>
  </div>
</template>

<style scoped>

</style>
